/*###########################################################################
// Third party
//#########################################################################*/

import consoleMessage from '@js/utilities/_console'

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(initThirdParties, 3500)
})
document.addEventListener('scroll', initThirdPartiesOnEvent)
document.addEventListener('mousemove', initThirdPartiesOnEvent)
document.addEventListener('touchstart', initThirdPartiesOnEvent)

function initThirdPartiesOnEvent(event) {
  initThirdParties()
  event.currentTarget.removeEventListener(event.type, initThirdPartiesOnEvent);
}

function initThirdParties() {
  if (window.thirdPartiesDidInit) {
    return false
  }
  window.dispatchEvent(new CustomEvent('first-user-interaction'))
  window.thirdPartiesDidInit = true

	// Init GTM
	//
	if (document.documentElement.hasAttribute('data-gtm-id')) {
		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.async = true
		script.onload = () => {
			dataLayer.push({ event: 'gtm.js', 'gtm.start': new Date().getTime(), 'gtm.uniqueEventId': 0 })
		}
		script.src = 'https://www.googletagmanager.com/gtm.js?id=' + document.documentElement.getAttribute('data-gtm-id')
		document.head.appendChild(script)

    consoleMessage("GTM loaded: " + document.documentElement.getAttribute('data-gtm-id'))

		// More reliable tracking of page changes, with GA4 data stream 'History tracking' turned off.
		// Requires custom GA4 Event adding to GTM.
		//
		window.addEventListener('after-page-change', () => {
			dataLayer.push({
				event: 'virtualPageview',
				page: {
					path: window.location.pathname + window.location.search,
					title: document.title,
				},
			})
		})
	}
}
